import clientHttp, { prefixBase } from '../../clientHttp';
import ResourceHttp from '../../resourceHttp';

class PerfilResourceHttp extends ResourceHttp {
  constructor(http, resource) {
    super();
    this.http = http;
    this.resource = resource;
  }

  findPermissao(id) {
    return this.http.get(`${this.resource}/${id}/permissoes`);
  }

  updatePermissao(data, id) {
    return this.http.put(`${this.resource}/${id}/permissoes`, data);
  }
}
const resource = 'perfil';

const perfilHttp = new PerfilResourceHttp(clientHttp, prefixBase + resource);

export default perfilHttp;
